import { Typography } from '@mui/material';

import { StatusTag } from '@app/components';
import { RoleStatus } from '@app/constants';
import { TableCellCustom } from '@app/components/table';
import { IRole } from '../types';
import { RowActions } from './row-actions';

interface Props {
  row: IRole;
  canAddRoles: string;
}

const RoleRow = (props: Props) => {
  const { row, canAddRoles } = props;

  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.name}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <StatusTag status={RoleStatus[row.active ? 1 : 0]} />
      </TableCellCustom>
      {canAddRoles ? (
        <TableCellCustom align="center" width={50}>
          <RowActions rows={row} />
        </TableCellCustom>
      ) : undefined}
    </>
  );
};

export { RoleRow };
